// import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { summaryApi } from '../../common';
// import { displayNGNCurrency } from '../../helpers/displayCurrency';
// import ViewSearch from '../../components/ViewSearch/ViewSearch';

// // const ProductCard = ({ product }) => (
// //   <div className="bg-white rounded-lg shadow-md p-4 hover:shadow-lg transition-shadow">
// //     <img 
// //       src={product.productImage[0]} 
// //       alt={product.productName} 
// //       className="w-full h-48 object-fit rounded-t-lg mix-blend-multiply"
// //     />
// //     <div className="mt-4">
// //       <h3 className="text-lg font-semibold text-gray-800">{product.productName}</h3>
// //       <p className="text-gray-600 mt-2">{product.productDescription}</p>
// //       <div className="flex justify-between items-center mt-4">
// //         <span className="text-xl font-bold text-blue-600">{displayNGNCurrency(product.productPrice)}</span>
// //         <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors">
// //           Add to Cart
// //         </button>
// //       </div>
// //     </div>
// //   </div>
// // );

// const SearchProducts = () => {
//   const location = useLocation();
//   const [products, setProducts] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);

//   const searchQuery = new URLSearchParams(location.search).get('q');

//   const fetchProducts = async () => {
//     if (!searchQuery) return;

//     setIsLoading(true);
//     try {
//       const response = await fetch(`${summaryApi.searchProducts.url}?q=${searchQuery}`);
//       const data = await response.json();
//       console.log("bissy", data)
//       setProducts(data?.data || []);
//     } catch (error) {
//       console.error('Failed to fetch products:', error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProducts();
//   }, [searchQuery]);

//   if (isLoading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-blue-500"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="container mx-auto p-4">
//       <h2 className="text-2xl font-bold mb-6">
//         Search Results for "{searchQuery}" ({products.length} items)
//       </h2>

//       {products.length === 0 ? (
//         <div className="text-center py-10 bg-gray-100 rounded-lg">
//           <p className="text-xl text-gray-600">No products found</p>
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
//           {products.map((product, index) => (
//             <ViewSearch key={product.id || index} product={product} />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchProducts;


import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { summaryApi } from '../../common';
import { useTheme } from '../../components/Theme/ThemeProvider';
import ViewSearch from '../../components/ViewSearch/ViewSearch';
import { Search, AlertCircle } from 'lucide-react';

const SearchProducts = () => {
  const location = useLocation();
  const { colors } = useTheme();
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const searchQuery = new URLSearchParams(location.search).get('q') || '';

  const fetchProducts = useCallback (async () => {
    if (!searchQuery.trim()) {
      setProducts([]);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${summaryApi.searchProducts.url}?q=${searchQuery}`);
      const data = await response.json();

      if (data.success) {
        setProducts(data.data || []);
      } else {
        setError(data.message || 'Failed to fetch products');
      }
    } catch (error) {
      console.error('Failed to fetch products:', error);
      setError('An error occurred while searching products');
    } finally {
      setIsLoading(false);
    }
  }, [searchQuery]);

  useEffect(() => {
    if (searchQuery.trim()) {
      fetchProducts();
    } else {
      setProducts([]);
    }
  }, [searchQuery, fetchProducts]);

  // Loading State
  if (isLoading) {
    return (
      <div 
        className='flex flex-col items-center justify-center min-h-screen mt-20'
        style={{ backgroundColor: colors.bg }}
      >
        <div 
          className='w-16 h-16 rounded-full border-4 border-transparent animate-spin'
          style={{
            borderTopColor: colors.primary,
            borderRightColor: colors.accent
          }}
        />
        <p 
          className='mt-4 text-lg font-semibold'
          style={{ color: colors.textSecondary }}
        >
          Searching products...
        </p>
      </div>
    );
  }

  // Error State
  if (error) {
    return (
      <div 
        className='container mx-auto p-4 mt-20 min-h-screen'
        style={{ backgroundColor: colors.bg }}
      >
        <div 
          className='p-8 rounded-lg flex items-center gap-4'
          style={{
            backgroundColor: `${colors.accent}20`,
            border: `2px solid ${colors.accent}`
          }}
        >
          <AlertCircle 
            size={32}
            style={{ color: colors.accent }}
          />
          <p 
            className='text-lg font-semibold'
            style={{ color: colors.accent }}
          >
            {error}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className='container mx-auto p-4 mt-20 min-h-screen transition-colors duration-300'
      style={{ backgroundColor: colors.bg }}
    >
      {/* Search Header */}
      {searchQuery && (
        <div className='mb-8'>
          <div className='flex items-center gap-3 mb-4'>
            <Search 
              size={32}
              style={{ color: colors.primary }}
            />
            <div>
              <h1 
                className='text-3xl md:text-4xl font-black'
                style={{ color: colors.text }}
              >
                Search Results
              </h1>
              <p 
                className='text-lg'
                style={{ color: colors.textSecondary }}
              >
                for "{searchQuery}"
              </p>
            </div>
          </div>

          {/* Results Count Badge */}
          <div
            className='inline-block px-4 py-2 rounded-full text-sm font-bold'
            style={{
              backgroundColor: colors.primaryLight,
              color: colors.primary
            }}
          >
            {products.length} {products.length === 1 ? 'result' : 'results'} found
          </div>

          {/* Decorative Line */}
          <div 
            className='h-1 w-20 rounded-full mt-4'
            style={{ backgroundColor: colors.primary }}
          />
        </div>
      )}

      {/* Empty State */}
      {products.length === 0 ? (
        <div 
          className='p-12 rounded-xl text-center'
          style={{
            backgroundColor: colors.bgSecondary,
            border: `2px dashed ${colors.border}`
          }}
        >
          <Search 
            size={48}
            className='mx-auto mb-4 opacity-50'
            style={{ color: colors.text }}
          />
          <p 
            className='text-xl font-semibold mb-2'
            style={{ color: colors.text }}
          >
            {searchQuery ? "No products found" : "Enter a search term to find products"}
          </p>
          <p 
            className='text-sm'
            style={{ color: colors.textSecondary }}
          >
            {searchQuery 
              ? `We couldn't find any products matching "${searchQuery}". Try a different search term.`
              : "Use the search bar to discover amazing products"
            }
          </p>
        </div>
      ) : (
        <div className='space-y-4'>
          {/* Results Info */}
          <div 
            className='p-4 rounded-lg'
            style={{
              backgroundColor: colors.bgSecondary,
              border: `1px solid ${colors.border}`
            }}
          >
            <p 
              className='text-sm font-medium'
              style={{ color: colors.textSecondary }}
            >
              Showing {products.length} {products.length === 1 ? 'product' : 'products'}
            </p>
          </div>

          {/* Products Grid */}
          <ViewSearch data={products} />
        </div>
      )}
    </div>
  );
};

export default SearchProducts;

// import React, { useEffect, useState } from 'react';
// import { useLocation } from 'react-router-dom';
// import { summaryApi } from '../../common';
// import ViewSearch from '../../components/ViewSearch/ViewSearch';

// const SearchProducts = () => {
//   const location = useLocation();
//   const [products, setProducts] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Memoize search query to prevent unnecessary re-renders
//   const searchQuery = new URLSearchParams(location.search).get('q') || '';

//   const fetchProducts = async () => {
//     // Early return if no search query
//     if (!searchQuery.trim()) {
//       setProducts([]);
//       return;
//     }

//     setIsLoading(true);
//     setError(null);

//     try {
//       const response = await fetch(`${summaryApi.searchProducts.url}?q=${searchQuery}`);
//       const data = await response.json();

//       if (data.success) {
//         setProducts(data.data || []);
//       } else {
//         setError(data.message || 'Failed to fetch products');
//       }
//     } catch (error) {
//       console.error('Failed to fetch products:', error);
//       setError('An error occurred while searching products');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     // Only fetch if there's a non-empty search query
//     if (searchQuery.trim()) {
//       fetchProducts();
//     } else {
//       setProducts([]);
//     }
//   }, [searchQuery]);

//   // Loading state
//   if (isLoading) {
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-blue-500"></div>
//       </div>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <div className="container mx-auto p-4 text-center">
//         <p className="text-red-500 text-xl">{error}</p>
//       </div>
//     );
//   }

//   return (
//     <div className="container mx-auto p-4">
//       {searchQuery && (
//         <h2 className="text-2xl font-bold mb-6">
//           Search Results for "{searchQuery}" ({products.length} items)
//         </h2>
//       )}

//       {products.length === 0 ? (
//         <div className="text-center py-10 bg-gray-100 rounded-lg">
//           <p className="text-xl text-gray-600">
//             {searchQuery 
//               ? "No products found" 
//               : "Enter a search term to find products"}
//           </p>
//         </div>
//       ) : (
//         <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//           {products.map((product) => (
//             <ViewSearch 
//               key={product._id || Math.random().toString()} 
//               data={product} 
//             />
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchProducts;